/**
 * <stats-carousel> — key-stats carousel.
 *
 * Auto mode: a CSS marquee (items are duplicated in markup; the track animates
 * translateX(-50%) for a seamless loop). This JS does nothing there, except that
 * if the visitor prefers reduced motion we fall back to a manual drag carousel.
 *
 * Manual mode: native scroll-snap + mouse drag + prev/next buttons.
 */
if (!customElements.get('stats-carousel')) {
  customElements.define(
    'stats-carousel',
    class StatsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        const auto = this.dataset.auto === 'true';
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Auto + motion allowed → pure-CSS marquee, nothing to wire up.
        if (auto && !reduced) return;

        // Manual (or auto downgraded by reduced-motion) → drag + buttons.
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByStep(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByStep(1));

        this.setupDrag();
      }

      step() {
        const item = this.track.querySelector('.stats-carousel__item');
        if (!item) return this.track.clientWidth;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      scrollByStep(direction) {
        this.track.scrollBy({ left: direction * this.step() * 2, behavior: 'smooth' });
      }

      setupDrag() {
        let dragging = false;
        let startX = 0;
        let startLeft = 0;

        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return;
          dragging = true;
          startX = event.clientX;
          startLeft = this.track.scrollLeft;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        });
        this.track.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          this.track.scrollLeft = startLeft - (event.clientX - startX);
        });
        const end = () => {
          dragging = false;
          this.track.classList.remove('is-dragging');
        };
        this.track.addEventListener('pointerup', end);
        this.track.addEventListener('pointercancel', end);
      }
    }
  );
}
